import generateImageUrl from "../../utils/generate-image-url";

const aboutUs = state => state.aboutUs;

const aboutUsLoading = state => state.aboutUsLoading;

const faq = state => state.faq;

const faqLoading = state => state.faqLoading;

const contactUs = state => state.contactUs;

const contactUsLoading = state => state.contactUsLoading;

const submitContactForm = state => state.submitContactForm;

const submitContactFormLoading = state => state.submitContactFormLoading;

const recruitByType = state => state.recruitByType;

const recruitByTypeLoading = state => state.recruitByTypeLoading;

const gettingStartedByType = state => state.gettingStartedByType;

const gettingStartedByTypeLoading = state => state.gettingStartedByTypeLoading;

const coachFeaturesByType = state => state.coachFeaturesByType;

const coachFeaturesByTypeLoading = state => state.coachFeaturesByTypeLoading;

const featuresByType = state => state.featuresByType;

const featuresByTypeLoading = state => state.featuresByTypeLoading;

const pricing = state => state.pricing;

const pricingLoading = state => state.pricingLoading;

const athletepricing = state => state.athletepricing;

const athletePricingLoading = state => state.athletePricingLoading;

const premiumclubHeadCoachPricing = state => state.premiumclubHeadCoachPricing;

const premiumclubHeadCoachPricingLoading = state =>
  state.premiumclubHeadCoachPricingLoading;

const formattedAthletePricingData = state => {
  return {
    pricingtype: [
      {
        icon: "layers.svg",
        type: "Basic",
        caption:
          "Enjoy our Basic Profile after your Free Trial which includes all your stats, pictures, and videos. Your profile will allow you to continue to be contacted by Club Teams.",
        features: [
          "Create a Free Profile",
          "Display your Pictures, Stats, and Video",
          "Appear in our searchable Player Database",
          "Receive messages of Interest from Club Teams",
          "Enjoy 2 weeks of our Premium Features"
        ],
        pricelist: ["0"]
      },
      {
        icon: "diamond.svg",
        type: "Premium",
        caption:
          "Continue to use all the tools you need to connect with great teams by upgrading to our Premium Membership Plan.",
        features: [
          "Create a Profile displaying your Pictures, Stats, Videos and Events",
          "See who has viewed your profile",
          "See when your messages have been viewed",
          "Search for Colleges, College Events, Clubs, and Club Events",
          "Use our Academic Filter to narrow down your College choices",
          "Email, Message, and Chat with College Coaches",
          "Message and Chat with Club Coaches",
          "Search for Club Tryouts, Friendlies, and Tournaments",
          "Manage multiple profiles under one login"
        ],
        pricelist:
          state.athletepricing.plans &&
          state.athletepricing.plans
            .filter(item => item.price != 0)
            .map(item => item.price)
      }
    ],
    faq: state.faq
  };
};

const formattedPremiumclubHeadCoachPricingData = state => {
  return {
    pricingtype: [
      {
        icon: "layers.svg",
        type: "Basic",
        caption:
          "Enjoy some of our great Free Features that are offered to all of our verified coaches.",
        features: [
          "Create a Profile displaying your Teams Pictures, Stats, Highlights, Videos and Events",
          "Search for and Find Players for your Team",
          "Search for Players, Clubs, and Club Events",
          "Appear in our searchable Club Team Database",
          "Message and Chat with Players and other Club Coaches",
          "Post Tryouts, Friendlies, and Tournaments",
          "Find local Friendlies and Tournaments"
        ],
        pricelist: ["0"]
      },
      {
        icon: "diamond.svg",
        type: "Premium",
        caption:
          "Upgrade to a Premium Membership to enhance your Team Profile and help your players proactively search for colleges.		",
        features: [
          "Create a Profile displaying your Teams Pictures, Stats, Highlights, Videos and Events",
          "Search for and Find Players for your Team",
          "Search for Players, Colleges, College Events, Clubs, and Club Events",
          "Create and Display Your Teams Roster",
          "Link Your Players Profiles to Your Team Roster",
          "Use our Filter to find Colleges for your Players",
          "Email, Message, and Chat with College Coaches",
          "Message and Chat with Players, College Coaches  and other Club Coaches",
          "Post Tryouts, Friendlies, and Tournaments",
          "Find local Friendlies and Tournaments"
        ],
        pricelist:
          state.premiumclubHeadCoachPricing.plans &&
          state.premiumclubHeadCoachPricing.plans
            .filter(item => item.price != 0)
            .map(item => item.price)
      }
    ],
    faq: state.faq
  };
};

const formattedFeaturesByType = state => ({
  headingDetail: {
    title: "Great Features",
    description: state.recruitByType.greatFeaturedescription
  },
  features: state.featuresByType.map(item => ({
    icon: generateImageUrl(item.icon),
    image: generateImageUrl(item.image),
    title: item.title,
    description: item.description
  }))
});

const formattedCoachFeaturesByType = state => ({
  headingDetail: {
    title: "Coach Specific Features",
    description: state.recruitByType.coachFeaturedescription
  },
  features: state.coachFeaturesByType.map(item => ({
    icon: generateImageUrl(item.icon),
    image: generateImageUrl(item.image),
    title: item.title,
    description: item.description
  }))
});

const formattedGettingStartedContent = state => ({
  headingDetail: {
    title: "Getting Started",
    description: state.recruitByType.gettingStartedDescription
  },
  features: state.gettingStartedByType.map(item => ({
    icon: generateImageUrl(item.icon),
    image: generateImageUrl(item.image),
    title: item.title,
    description: item.description
  }))
});

const formattedContactDetails = state => {
  return [
    {
      icon: "mail",
      title: "Email",
      detail: state.contactUs.displayEmail,
      type: "mail",
      href: `mailto:${state.contactUs.displayEmail}`
    },
    {
      icon: "phone",
      title: "Phone",
      detail: state.contactUs.displayPhone,
      type: "tel",
      href: `tel:${state.contactUs.displayPhone}`
    },
    {
      icon: "pushpin",
      title: "Main Office",
      detail: state.contactUs.officeLocation,
      type: "location",
      href: `${state.contactUs.officeLocation}`
    }
  ];
};

const pricingDetail = state => state.pricingDetail;

const pricingDetailLoading = state => state.pricingDetailLoading;

const formattedPricingDetail = state => ({
  pricingType: [
    {
      icon: "layers.svg",
      type: "Basic",
      caption:
        "Enjoy some of our great Free Features that are offered to all of our verified coaches.",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist: ["0"]
    },
    {
      icon: "diamond.svg",
      type: "Premium",
      caption:
        "Upgrade to a Premium Membership to enhance your Team Profile and help your players proactively search for colleges",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist:
        state.pricingDetail.plans &&
        state.pricingDetail.plans
          .filter(item => item.price != 0)
          .map(item => item.price)
    }
  ]
});

const formattedAtheletePricingDetail = state => ({
  pricingType: [
    {
      icon: "layers.svg",
      type: "Basic",
      caption:
        "Enjoy our Basic Profile after your Free Trial which includes all your stats, pictures, and videos. Your profile will allow you to continue to be contacted by Club Teams",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist: ["0"]
    },
    {
      icon: "diamond.svg",
      type: "Premium",
      caption:
        "Continue to use all the tools you need to connect with great teams by upgrading to our Premium Membership Plan.",
      features: [
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile",
        "Athlete can get the detailed profile"
      ],
      pricelist:
        state.pricingDetail.plans &&
        state.pricingDetail.plans
          .filter(item => item.price != 0)
          .map(item => item.price)
    }
  ]
});

const pricingDetaiPictures = state => state.pricingDetaiPictures;

const pricingDetaiPicturesLoading = state => state.pricingDetaiPicturesLoading;

const privacyPolicy = state => state.privacyPolicy;

const privacyPolicyLoading = state => state.privacyPolicyLoading;

const termsAndConditions = state => state.termsAndConditions;

const termsAndConditionsLoading = state => state.termsAndConditionsLoading;

export default {
  aboutUs,
  aboutUsLoading,
  faq,
  faqLoading,
  contactUs,
  contactUsLoading,
  formattedContactDetails,
  submitContactForm,
  submitContactFormLoading,
  recruitByType,
  recruitByTypeLoading,
  gettingStartedByType,
  gettingStartedByTypeLoading,
  formattedGettingStartedContent,
  coachFeaturesByType,
  coachFeaturesByTypeLoading,
  formattedCoachFeaturesByType,
  featuresByType,
  featuresByTypeLoading,
  formattedFeaturesByType,
  pricing,
  pricingLoading,
  athletepricing,
  athletePricingLoading,
  premiumclubHeadCoachPricing,
  premiumclubHeadCoachPricingLoading,
  formattedAthletePricingData,
  formattedPremiumclubHeadCoachPricingData,
  pricingDetail,
  pricingDetailLoading,
  formattedPricingDetail,
  formattedAtheletePricingDetail,
  pricingDetaiPictures,
  pricingDetaiPicturesLoading,
  privacyPolicy,
  privacyPolicyLoading,
  termsAndConditions,
  termsAndConditionsLoading
};
